




import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import PdfPluginViewer from "./PdfPluginViewer.vue";
import PdfjsViewer from "./PdfjsViewer.vue";

@Component({
  components: {
    Plugin: PdfPluginViewer,
    Renderer: PdfjsViewer,
  }
})
export default class PdfViewer extends Mixins() {
  @Prop()
  src: string;

  @Prop({ default: 1 })
  page: number;

  @Prop({ default: "Fit" })
  view: "" | "Fit" | "FitH" | "FitV";

  @Prop({ default: 0 })
  zoom: number;

  @Prop()
  forceEnableOpenTypeFontFace: boolean;

  @Prop({ default: false })
  shouldRenderByPluginForcibly: boolean; // 利用側にRendererかPluginか意識させたくなかったが管理外文書かを渡す方が変なので追加.
  
  data() {
    return {
      key: "Plugin",
    };
  }
  key: "Plugin" | "Renderer";

  mounted() {
    this.initializeKey();
  }

  private initializeKey() {
    this.key = !this.shouldRenderByPluginForcibly && (this.$configuration.system.pdfRendering.shouldRenderSelf || this.isMobile)
      ? "Renderer"
      : "Plugin";
  }

  @Watch("shouldRenderByPluginForcibly")
  onShouldRenderByPluginForcibly(newValue: boolean) {
    this.initializeKey();
  }

  changePdfViewer(): void {
    this.key = this.key === "Plugin"
      ? "Renderer"
      : "Plugin";
  }

  get isMobile(): boolean {
    return this.$route.meta.isMobile;
  }
}
